export default __webpack_public_path__ + "img/safety-overrides.8109088a.png";